<template>
  <VuePerfectScrollbar class="scroll-area" v-once :settings="settings">
    <div id="product-list">
      <vx-card class="mb-base">
        <div class="vx-row mb-12 ml-0">
          <vs-button
            icon-pack="feather"
            icon="icon-skip-back"
            color="success"
            class="mr-4"
            type="border"
            :to="{name: 'payCard'}"
          ></vs-button>
          <h3 class="mt-2">Müşteri Bilgileri</h3>
        </div>

        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-payViewiner mb-4">
              <img
                :src="viewData.avatar?viewData.avatar:this.$defaultPicture"
                class="rounded w-full"
              />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Adı Soyadı:</td>
                <td>{{viewData.firstName}}</td>
              </tr>

              <tr>
                <td class="font-semibold">Email:</td>
                <td>
                  <a v-bind:href="'mailto:' + viewData.email">{{viewData.email}}</a>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Üyelik Tarihi:</td>
                <td>{{viewData.createdDate}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Müşteri Hesap:</td>
                <td id="amount"></td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table></table>
          </div>
          <!-- /Information - Col 2 -->
        </div>
      </vx-card>

      <!-- Siparişler -->
      <vx-card class="mb-base">
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="BookOpenIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Siparişler</span>
            </div>
            <vs-divider />
          </div>
        </div>

        <div class="block overflow-x-auto tableHeight">
          <table class="w-full">
            <tr>
              <th
                class="font-semibold text-base text-left px-3 py-2"
                v-for="heading in ['Siparis No', 'Fiyat']"
                :key="heading"
              >{{ heading }}</th>
            </tr>

            <tr
              :key="product.id"
              v-for="product in myProducts"
            >{{ product.name }} - {{ product.qty }}</tr>
            <div class="vx-col justify-end w-full flex" id="account-manage-buttons">
              <vs-button
                color="danger"
                icon-pack="feather"
                icon="icon-trash"
                @click="removeProduct(product)"
              >Sepetten Çıkar</vs-button>
            </div>
          </table>
        </div>
      </vx-card>
      <!-- /Siparişler -->

      <!--ürün seç -->
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card class="mb-base">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="flex items-end px-3">
                  <feather-icon svgClasses="w-6 h-6" icon class="mr-2" />
                  <span class="font-medium text-lg leading-none">Ürün Seç</span>
                </div>
                <vs-divider />
              </div>
            </div>
            <table>
              <tr>
                <div :key="product.id" class="col-sm-6 col-md-4" v-for="product in products">
                  <div class="thumbnail">
                    <div class="caption">
                      <h3>{{ product.name }}</h3>
                      <p>{{ product.desc }}</p>
                      <p>{{ product.price }} TL</p>
                      <p>
                        <a
                          class="btn btn-primary"
                          role="button"
                          v-on:click="addProduct(product)"
                        >Sepete Ekle</a>
                      </p>
                    </div>
                  </div>
                </div>
              </tr>
            </table>
          </vx-card>
        </div>
        <!-- /ürün seç -->
        <!-- Bakiye -->
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card class="mb-base">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="flex items-end px-3">
                  <feather-icon svgClasses="w-6 h-6" icon="CreditCardIcon" class="mr-2" />
                  <span class="font-medium text-lg leading-none">Bakiye Bilgileri</span>
                </div>
                <vs-divider />
              </div>
            </div>
            <table>
              <tr>
                <td class="font-semibold">Vergi No:</td>
                <td>
                  <span v-if="myProducts.length != 0">{{ productTotal }} TL</span>
                </td>
              </tr>
            </table>
          </vx-card>
        </div>
        <!-- /Bakiye -->
      </div>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import agGridTable from "../sales/addComponents/agGridTable.vue";

export default {
  components: {
    VuePerfectScrollbar,
    agGridTable,
  },
  data() {
    return {
      selectedProducts: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        suppressScrollX: true,
      },
      viewData: {},
      // Uygulamamızda kullanacağımız değişkenleri tanımladık
      myProducts: [], // Sepetimiz ( Şu an boş )
      products: [
        {
          // Dummy datalarımızı oluşturduk test amaçlı
          id: 0,
          name: "Ürün 1", // Ürünün Adı
          desc: "Açıklama", // Ürünün Açıklaması
          // Ürünün Fotoğrafı
          price: 20, // Ürününü Fiyatı
        },
        {
          id: 1,
          name: "Ürün 2",
          desc: "Açıklama",
          price: 40,
        },
        {
          id: 2,
          name: "Ürün 3",
          desc: "Açıklama",
          price: 60,
        },
      ],
    };
  },

  computed: {
    productTotal: function () {
      var total = 0;
      var item;

      for (item in this.myProducts) {
        total = total + this.myProducts[item].qty * this.myProducts[item].price;
      }

      return total;
    },
  },
  methods: {
    closeSelected() {},
    changeSelected() {
      for (let i = 0; i < this.currentItem.products.length; i++) {
        let e = this.currentItem.products[i];
        this.selectedProducts.push({
          price: e.price,
          priceWithTaxes: 0,
          productCategory: "Diğer",
          productCategoryID: 4,
          productDescription: null,
          productId: e.productId,
          productName: e.productName,
          quantity: e.productAmount,
          sellPrice: e.priceDiscounted || e.price,
          stock: 1,
          wareHouse: null,
          wareHouseId: e.wareHouseId,
          isEdit: true,
          id: e.orderLineId,
        });
      }
    },
    // Uygulamamızda kullanacağımız methodları tanımladık
    addProduct: function (item) {
      if (this.myProducts.length == 0) {
        this.myProducts.push({
          id: item.id,
          name: item.name,
          desc: item.desc,
          price: item.price,
          qty: 1,
        });
      } else {
        var repeatItem = false;
        var pItem;

        for (pItem in this.myProducts) {
          if (this.myProducts[pItem].id == item.id) {
            this.myProducts[pItem].qty = this.myProducts[pItem].qty + 1;
            repeatItem = true;
          }
        }

        if (!repeatItem) {
          this.myProducts.push({
            id: item.id,
            name: item.name,
            desc: item.desc,
            price: item.price,
            qty: 1,
          });
        }
      }
    },
    removeProduct: function (item) {
      if (this.myProducts.length == 0) {
        this.myProducts.push({
          id: item.id,
          name: item.name,
          desc: item.desc,
          price: item.price,
          qty: 1,
        });
      } else {
        var repeatItem = false;
        var pItem;

        for (pItem in this.myProducts) {
          if (this.myProducts[pItem].id == item.id) {
            this.myProducts[pItem].qty = this.myProducts[pItem].qty - 1;
            repeatItem = true;
          }
        }

        if (!repeatItem) {
          this.myProducts.push({
            id: item.id,
            name: item.name,
            desc: item.desc,
            price: item.price,
            qty: 1,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vue-star-rating-rating-text {
  display: none;
}
#avatar-col {
  width: 10rem;
}

#product-list {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
.amount-container {
  margin-bottom: 5px;
}
.amount {
  margin-right: 10px;
  font-weight: bolder;
}
.amount.red {
  color: red;
}
.tableHeight {
  height: 170px;
  th,
  td {
    height: 40px !important;
  }
}
</style>